import { createContext } from "react";
import { FeatureFlagManager } from "./FeatureFlagManager.ts";

type FeatureFlagContextType = {
  featureFlagManager: FeatureFlagManager | null;
};

export const FeatureFlagContext = createContext<FeatureFlagContextType>({
  featureFlagManager: null,
});
